// src/store/useCartStore.ts
import { create } from "zustand";
import { persist } from "zustand/middleware";

export interface CartItem {
  ProductId: number;
  ProductIdentityId: number;
  count: number;
  /** قیمت عادی در لحظهٔ افزودن به سبد */
  unitPrice: number;
  /** قیمت تخفیف در لحظهٔ افزودن (صفر یعنی بدون تخفیف) */
  unitDiscount: number;
  property?: { attr: string; property: string }[];
}

interface CartStore {
  cart: CartItem[];
  /** item باید شامل unitPrice و unitDiscount باشد */
  addCard: (item: CartItem) => void;
  removeFromCart: (id: number) => void;
  increaseCard: (id: number) => void;
  decreaseCard: (id: number) => void;
  clearCart: () => void;
}

const useCartStore = create<CartStore>()(
  persist(
    (set) => ({
      cart: [],

      addCard: (newItem) =>
        set((state) => {
          const idx = state.cart.findIndex(
            (c) => c.ProductIdentityId === newItem.ProductIdentityId
          );
          const cart =
            idx > -1
              ? state.cart.map((c) =>
                  c.ProductIdentityId === newItem.ProductIdentityId
                    ? { ...c, count: c.count + newItem.count }
                    : c
                )
              : [...state.cart, newItem];
          return { cart };
        }),

      removeFromCart: (id) =>
        set((state) => ({
          cart: state.cart.filter((c) => c.ProductIdentityId !== id),
        })),

      increaseCard: (id) =>
        set((state) => ({
          cart: state.cart.map((c) =>
            c.ProductIdentityId === id ? { ...c, count: c.count + 1 } : c
          ),
        })),

      decreaseCard: (id) =>
        set((state) => ({
          cart: state.cart
            .map((c) =>
              c.ProductIdentityId === id
                ? { ...c, count: Math.max(c.count - 1, 0) }
                : c
            )
            .filter((c) => c.count > 0),
        })),

      clearCart: () => set({ cart: [] }),
    }),
    { name: "shopping-cart" }
  )
);

export default useCartStore;
